import React, { useState } from 'react';
import Link from 'next/link';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { GTM_ACTION, GTM_CLASS, GTM_CLASS_PREFIX } from '../../../lib/constant';
import LeadFormModal from '../../modal/LeadFormModal/LeadFormModal';
import useWebView from '../../../utils/hooks/useWebView';

import styles from './FooterBanner.module.scss';

interface IFooterBanner {
  slug?: string;
  banner?: any;
}

const FooterBanner = (props: IFooterBanner) => {
  const { slug, banner } = props;
  const [isShowPopup, setIsShowPopup] = useState(false);
  const isWebView = useWebView();
  const [popupData, setPopupData] = useState({
    isOpen: false,
    title: '',
    category: 'auto',
    category_value: 'auto',
    useTimer: false,
  });
  const router = useRouter();

  const showPopup = (data) => {
    setPopupData(data);
    setIsShowPopup(true);
  };

  const ldnBanner = (data) => {
    const alt = data.linkTitle || 'Footer Banner';
    const url = data.linkUrl ? `${data.linkUrl}&utm_content=${slug}` : '';

    if (data.type === 'POPUP' && data.imageMobileUrl) {
      const popupDataLDN = {
        bannerMobileUrl: data.imageMobileUrl,
        bannerDesktopUrl: data.imageDesktopUrl,
        title: data.leadFormTitle,
        category: data.leadForm,
        category_value: data.leadForm,
        useTimer: false,
        isOpen: true,
        gtmAction: GTM_ACTION.FOOTER_BANNER,
      };
      return (
        <div
          onClick={() => showPopup(popupDataLDN)}
          className={classnames(
            GTM_CLASS.OPEN_LEADFORM_FOOTER_BANNER,
            `${GTM_CLASS_PREFIX}${data.leadForm}`,
            `${styles.ldnBanner}`,
          )}
        >
          <img src={data.imageMobileUrl} width={360} height={50} alt={alt} loading="lazy" />
        </div>
      );
    } else {
      return (
        <Link href={url}>
          <a className={styles.ldnBanner} title={alt}>
            <img src={data.imageMobileUrl} width={360} height={50} alt={alt} loading="lazy" />
          </a>
        </Link>
      );
    }
  };

  const stickyBanner = (data, pageSlug) => {
    return (
      <div className={styles.stickyBanner}>
        <div
          className={styles.stickyBanner__title}
          dangerouslySetInnerHTML={{
            __html: data ? data.linkTitle : '',
          }}
        />
        <div className={styles.stickyBanner__buttons}>
          {data &&
            data.buttons &&
            data.buttons.map((button) => {
              let popupDataSticky = {};
              if (button.type === 'POPUP') {
                popupDataSticky = {
                  bannerMobileUrl: button.leadFormImageUrl,
                  bannerDesktopUrl: button.leadFormImageUrl,
                  title: button.leadFormTitle,
                  category: button.leadForm,
                  category_value: button.leadForm,
                  useTimer: false,
                  isOpen: true,
                  gtmAction: GTM_ACTION.FOOTER_BANNER,
                };
              }

              const url =
                button.type === 'POPUP'
                  ? '#'
                  : encodeURI(`${button.linkUrl}&utm_content=${pageSlug}`.replace(/&amp;/g, '&'));
              return (
                <Link href={url} key={button.linkTitle}>
                  <a
                    title={button.linkTitle}
                    className={classnames(
                      GTM_CLASS.OPEN_LEADFORM_FOOTER_BANNER,
                      `${GTM_CLASS_PREFIX}${button.leadForm}`,
                    )}
                    onClick={() => {
                      if (button.type === 'POPUP') {
                        showPopup(popupDataSticky);
                      }

                      return;
                    }}
                  >
                    <img
                      src={`${router.basePath}/static/images/icons/${button.icon}.svg`}
                      className={styles['stickyBanner__buttons-icon']}
                      alt={button.linkTitle}
                      loading="lazy"
                      width={14}
                      height={14}
                    />
                    <span className={styles['stickyBanner__buttons-title']}>
                      {button.linkTitle}
                    </span>
                  </a>
                </Link>
              );
            })}
        </div>
      </div>
    );
  };

  const setStickyBanner = () => {
    if (banner && banner.isOverride && banner.ldnBanner) return ldnBanner(banner.ldnBanner);
    else if (banner && banner.stickyBanner) return stickyBanner(banner.stickyBanner, slug);
    else return '';
  };

  return (
    <>
      {isShowPopup && (
        <LeadFormModal popupData={popupData} closePopup={() => setIsShowPopup(false)} />
      )}
      {!isWebView && <div className={styles.footerBanner}>{setStickyBanner()}</div>}
    </>
  );
};

export default FooterBanner;
